import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import '../../../css/core/components/TextBoxComponent.scss';


class TextBoxComponent extends React.Component {
  state = {
    textInput: this.props.selectedValue,
  }

  handleChange(event) {
    const { handleChange, field } = this.props;
    this.setState({
      textInput: event.target.value,
    }, () => handleChange(field, this.state.textInput));
  }

  render() {
    const {
      title, fieldKey, fieldType, editable, multiline, rows, fieldAutoFocus,
    } = this.props;

    return (
      <TextField
        key={fieldKey}
        value={this.state.textInput}
        label={title}
        placeholder={title}
        onChange={e => this.handleChange(e)}
        className="textBoxComponent-textFieldStyle"
        variant="outlined"
        InputProps={{ disableUnderline: true }}
        FormHelperTextProps={{ className: 'textBoxComponent-textFieldHelperText' }}
        id={fieldKey}
        autoFocus={fieldAutoFocus}
        multiline={multiline}
        rows={rows}
        inputProps={
          multiline ? { className: 'textBoxComponent-inputInformationStyle' } : { className: 'textBoxComponent-inputStyle' }
        }
        type={fieldType}
        disabled={!editable}
      />
    );
  }
}

TextBoxComponent.propTypes = {
  handleChange: PropTypes.func.isRequired,
  field: PropTypes.objectOf(PropTypes.any).isRequired,
  title: PropTypes.string.isRequired,
  fieldKey: PropTypes.string.isRequired,
  fieldType: PropTypes.string,
  selectedValue: PropTypes.string,
  editable: PropTypes.bool,
  multiline: PropTypes.bool,
  rows: PropTypes.string,
  fieldAutoFocus: PropTypes.bool,
};

TextBoxComponent.defaultProps = {
  fieldType: 'string',
  selectedValue: '',
  editable: true,
  multiline: false,
  rows: '5',
  fieldAutoFocus: true,
};

export default (TextBoxComponent);
